module.exports = __webpack_public_path__ + "static/c9-c2624adb53b61336eba64515be21c9f8.jpg";